import type { ResultOf, VariablesOf } from 'gql.tada';
import { gql } from '@/utilities/gql';
import { makeGqlMutation } from '@/utilities/gqlQuery';
import { useMutationWithSnackbar } from '../useMutationWithSnackbar';

const MUTATION = gql(
  `
  mutation startNarrative($companyId: ID!) {
    startNarrative(companyId: $companyId) {
      id
      draftUpdate {
        id
      }
    }
  }
`
);

export type StartNarrativeInput = VariablesOf<typeof MUTATION>;
export type StartNarrativeResult = ResultOf<typeof MUTATION>;

const useStartNarrative = makeGqlMutation(MUTATION);

type StartNarrativeWithSnackbarOptions = {
  errorMessage?: string;
  includeSuccessSnackbar?: boolean;
  successMessage?: string;
};

export const useStartNarrativeWithSnackbar = (
  options: StartNarrativeWithSnackbarOptions = {}
) => {
  const mutation = useStartNarrative();
  return useMutationWithSnackbar(mutation, {
    errorMessage: options.errorMessage || 'Failed to start narrative',
    includeSuccessSnackbar: options.includeSuccessSnackbar || false,
    successMessage: options.successMessage || 'Successfully started narrative',
  });
};
